import { UserModel } from '@akin-home/user';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components/native';
import SwitchProfileMemberItem from '../SwitchProfileMemberItem';

interface Props {
  users?: UserModel[];

  onPressMember?: (user: UserModel) => void;
}

const SwitchProfileMemberGrid: FC<Props> = (props) => {
  const { users, onPressMember } = props;

  const user_rows = useMemo(
    () =>
      (users || []).reduce(
        (acc, curr) => {
          const idx = acc.length - 1;

          if (acc[idx].length === 3) {
            acc.push([curr]);
          } else {
            acc[idx].push(curr);
          }

          return acc;
        },
        [[]] as UserModel[][]
      ),
    [users]
  );

  return (
    <Container>
      {user_rows?.map((user_row, idx) => (
        <MemberGridRow key={idx}>
          {user_row.map((user) => (
            <MemberItemContainer key={user.id}>
              <SwitchProfileMemberItem user={user} onPress={onPressMember} />
            </MemberItemContainer>
          ))}

          {/* {onPressAddMember && (user_row.length < 4 || idx === user_rows.length - 1) ? (
            <AddMemberContainer onPress={onPressAddMember}>
              <AddMemberSquare>
                <FontAwesomeIcon icon="plus" size={30} />
              </AddMemberSquare>
              <Spacer height="16px" />
              <Text weight="semibold">Add member</Text>
            </AddMemberContainer>
          ) : null} */}
        </MemberGridRow>
      ))}
    </Container>
  );
};

const Container = styled.View`
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
`;

const MemberGridRow = styled.View`
  flex-direction: row;
  padding-bottom: 32px;

  width: 100%;
`;

const MemberItemContainer = styled.View`
  flex: 1;
`;

const AddMemberSquare = styled.View`
  height: 86px;
  width: 86px;

  border-radius: 30px;
  justify-content: center;
  align-items: center;

  background-color: rgba(5, 22, 51, 0.1);
`;

const AddMemberContainer = styled.TouchableOpacity`
  align-items: center;
  flex: 1;
`;

export default SwitchProfileMemberGrid;
